/* eslint-disable */
import React from 'react'
import { isInDomain } from 'AccountsUtils'
import SVGComponent from '../../SVGComponent'
import CTLogo from './ct_logo.colored.svg'
import CTLogoOld from './oldLogo.svg'

const Support_header = () => {
  const isFlyin = () => {
    return window.location.hostname.includes('flyin')
  }

  const renderFlyinHeader = () => {
    return (
      <div className="Header clearfix">
        <div className="" style={{ paddingTop: '10px' }}>
          <a href="/">
            <img
              src="https://ui.cltp.co/flyinstatic/common/themes/v1/images/flyinLogo.png"
              style={{ height: '36px' }}
              alt="Flyin Logo"
            />
          </a>
        </div>
      </div>
    )
  }
  if (isFlyin()) {
    return renderFlyinHeader()
  }
  return (
    <div className="Header clearfix">
      <div
        className="Header__menu"
        onClick={() => {
          window.location.href = '/my-account'
        }}
      >
        <SVGComponent svgIcon="arrow_left_pwa" className="c-inherit" />
      </div>
      <div>
        <If condition={isInDomain()}>
          <CTLogo className="Header__logo" />
          <Else />
          <CTLogoOld />
        </If>
      </div>
    </div>
  )
}

export default Support_header
